import { useCallback } from 'react';
import transformContactsToBorrower from '../utils';

const useScheduleTableExternalData = (
  fetchSchedulesFromExternalDirectly,
  match,
  contacts,
  setSearchButtonClicked,
  setNoPropertiesModalVisible,
  setModalWindowVisible,
  fetchSchedules,
) => {
  const onAppend = useCallback(() => {
    setModalWindowVisible(false);
    fetchSchedulesFromExternalDirectly(
      match.params.token,
      transformContactsToBorrower(contacts),
    )
      .then((response) => {
        if (response.collection.properties.length === 0) {
          setNoPropertiesModalVisible(true);
        }

        fetchSchedules(match.params.token);
      });
    setSearchButtonClicked(false);
  }, [
    setModalWindowVisible,
    fetchSchedulesFromExternalDirectly,
    match.params.token,
    contacts,
    setNoPropertiesModalVisible,
    fetchSchedules,
    setSearchButtonClicked,
  ]);

  const onReplace = useCallback(() => {
    setModalWindowVisible(false);
    fetchSchedulesFromExternalDirectly(
      match.params.token,
      transformContactsToBorrower(contacts),
      true,
    )
      .then((response) => {
        if (response.collection.properties.length === 0) {
          setNoPropertiesModalVisible(true);
        }

        fetchSchedules(match.params.token);
      });
    setSearchButtonClicked(false);
  }, [
    setModalWindowVisible,
    fetchSchedulesFromExternalDirectly,
    match.params.token,
    contacts,
    setNoPropertiesModalVisible,
    fetchSchedules,
    setSearchButtonClicked,
  ]);

  const onCancel = useCallback(() => {
    setModalWindowVisible(false);
    setSearchButtonClicked(false);
  }, [setModalWindowVisible, setSearchButtonClicked]);

  return {
    onAppend,
    onReplace,
    onCancel,
  };
};

export default useScheduleTableExternalData;
